import { NaviTableColumnDef } from '@cp/src/components/NaviTable/interfaces';
import { Typography } from '@navi/web-ui/lib/primitives';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import { copyToClipboard } from '@cp/src/utils/commonUtils';
import { AllocationData } from './types';
import { Dispatch } from 'react';
import CaseCountTooltip from './components/CaseCountTooltip';
import AllocationActionsCell from './AllocationActionsCell';

const handleQueryCopy = (query: string) => {
  copyToClipboard(query);
  toast.success('Query copied to clipboard');
};

export const getAllocationColumnDefs = (
  onEdit: (id: string) => void,
  onDuplicate: (id: string) => void
): NaviTableColumnDef<AllocationData>[] => {
  return [
    {
      header: 'Allocation team',
      accessorKey: 'allocationTeam',
      size: 120,
      cell: ({ row }) => (
        <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
          {row.original.allocationTeam}
        </Typography>
      )
    },
    {
      header: 'Allocation purpose',
      accessorKey: 'allocationPurpose',
      size: 140,
      cell: ({ row }) => (
        <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
          {row.original.allocationPurpose}
        </Typography>
      )
    },
    {
      header: 'Case DPD bucket',
      accessorKey: 'caseExpiryDays',
      size: 120,
      cell: ({ row }) => (
        <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
          {row.original.dpdBucket}
        </Typography>
      )
    },
    {
      header: 'Case Team',
      accessorKey: 'caseTeam',
      size: 100,
      cell: ({ row }) => (
        <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
          {row.original.caseTeam}
        </Typography>
      )
    },
    {
      header: 'Case Expiry (days)',
      accessorKey: 'caseExpiryDays',
      size: 120,
      cell: ({ row }) => (
        <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
          {row.original.caseExpiryDays}
        </Typography>
      )
    },
    {
      header: 'Allocation dates',
      accessorKey: 'allocationDates',
      size: 120,
      cell: ({ row }) => (
        <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
          {Array.isArray(row.original.allocationDates)
            ? row.original.allocationDates.join(', ')
            : row.original.allocationDates}
        </Typography>
      )
    },
    {
      header: 'DPD exclusion',
      accessorKey: 'dpdExclusions',
      size: 120,
      cell: ({ row }) => (
        <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
          {Array.isArray(row.original.dpdExclusions)
            ? row.original.dpdExclusions.join(', ')
            : row.original.dpdExclusions}
        </Typography>
      )
    },
    {
      header: () => (
        <div className="flex items-center gap-1">
          <Typography variant="p3" color={'var(--navi-color-gray-c3)'}>
            Number of cases
          </Typography>
          <CaseCountTooltip />
        </div>
      ),
      accessorKey: 'numberOfCases',
      size: 120,
      cell: ({ row }) => (
        <div className="flex items-center gap-[6px]">
          <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
            Copy
          </Typography>
          <CopyToClipboardIcon
            width={20}
            height={20}
            onClick={() => handleQueryCopy(row.original.casesQuery)}
            className="cursor-pointer"
          />
        </div>
      )
    },
    {
      header: 'Actions',
      accessorKey: 'id',
      size: 100,
      cell: ({ row }) => (
        <AllocationActionsCell row={row.original} onEdit={onEdit} onDuplicate={onDuplicate} />
      )
    }
  ];
};
